// extracted by mini-css-extract-plugin
export default {"negative-margin":"marketplace-navigation-module__negative-margin--JLtA1"};